export enum DisplayMode {
  LIST,
  GALLERY,
}
